import {Component, OnInit, Injector, OnDestroy, AfterViewInit, ViewChild} from '@angular/core';
import {UntypedFormBuilder, FormControl, UntypedFormGroup, Validators} from '@angular/forms';

import {GlmModalService} from '../../../_components/glm-modal/glm-modal.service';
import { HttpClient } from '@angular/common/http';
import {EstudioService} from '../estudio.service';
import {MapaCurricularService} from '../mapa-curricular/_services/mapa-curricular.service';
import {CustomAlertService} from '../../../_components/custom-alert/custom-alert.service';
import {Evento} from '../../../_models/evento';
import {EventoUnidad} from '../../../_models/evento-unidad';
import {UnidadEtapasService} from '../unidad-etapas/_services/unidad-etapas.service';
import {MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';
import {ComentariosService} from '../../../_components/glm-comentarios/comentarios.service';
import {Comentario} from '../../../_models/comentario';
import {GapiPickerService} from '../../../_services/gapi-picker';
import {BehaviorSubject, combineLatest, from, Observable, of, Subject, Subscription} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {AuthenticationService} from '../../../_services';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import {MY_FORMATS} from '../../../_models/moment-formats';
import { GoogleClass } from 'src/app/_models/googleClassroom/google-class';
import { ClassroomService } from 'src/app/_services/classroom.service';
import { buffer, bufferWhen, catchError, concatMap, flatMap, map, mergeMap, shareReplay, tap, toArray } from 'rxjs/operators';
import { GlobalService } from 'src/app/_services/global.service';
import { CkeditorImageDeleteDirective } from 'src/app/_directives/ckeditor-image-delete/ckeditor-image-delete.directive';

const API_URL = environment.apiUrl;

@Component({
  selector: 'evento-form',
  standalone: false,
  templateUrl: 'evento-form.component.html',
  styleUrls: ['../unidad-etapas/unidad-etapas-generales.scss','../meta-form/meta-form-component.scss','evento-form.component.scss'],
  providers: [
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS}
  ]
})

export class EventoFormComponent implements OnInit, AfterViewInit, OnDestroy {

  eventoForm: UntypedFormGroup;

  _eventoUnidad: EventoUnidad;
  _eventoResumenInit: string;
  tiposEvento: any[];
  cursosOpt: any[];
  areas: any[];
  profesores: any[];
  ambitos: any[];
  tags: any[];

  comentariosEvento: Comentario[] = [];

  materiasPeriodo$: Observable<any[]>;

  materiasPeriodoInit$: Observable<any[]>;

  guardando = false;
  editMainContent = true;
  activeTab: any = 0;

  ckeditorImageEndPoint = `${API_URL}/api/storage/uploadimg`;
  refreshUrl = `${API_URL}/api/jwt/refresh`;
  userToken;
  refreshToken;

  gapiPickerSubscriber: Subscription;

  classroomButtonLoaded = false;

  courses$: Observable<GoogleClass[]>;

  tareas$: Observable<any[]>;

  eventosMateriaSubject: BehaviorSubject<any[]>;
  eventosMateria$: Observable<any[]>;

  cambiosSubscription: Subscription;

  @ViewChild(CkeditorImageDeleteDirective) imageDelete: CkeditorImageDeleteDirective;

  constructor(private fb: UntypedFormBuilder,
              private injector: Injector,
              // private http: HttpClient,
              private snackBar: MatSnackBar,
              private pickerService: GapiPickerService,
              private estudioService: EstudioService,
              // private mapaCurricularService: MapaCurricularService,
              private unidadEtapasService: UnidadEtapasService,
              private modalService: GlmModalService,
              private customAlertService: CustomAlertService,
              private comentariosService: ComentariosService,
              private classroomService: ClassroomService,
              private globalService: GlobalService,
              private authService: AuthenticationService
              ) {
    this.userToken = authService.currentUserValue.token;
    this.refreshToken = authService.currentUserValue.refresh;
  }

  ngOnInit() {
    this._eventoUnidad = {...this.injector.get('evento', {})};
    this.tiposEvento = this.injector.get('categorias', []);
    this.cursosOpt = this.injector.get('cursos', []);
    this.areas = this.injector.get('areas', []);
    this.profesores = this.injector.get('profesores', []);
    this.ambitos = this.injector.get('ambitos', []);
    this.tags = this.injector.get('tags', []);
    this.materiasPeriodoInit$ = of(this.injector.get('materiasPeriodo', []));
    this.activeTab = this.injector.get('tabActiva', 0);

    const mcpsConCourses$ = this.materiasPeriodoInit$.pipe(
      concatMap(data => {
        return this.classroomService.getListaAsociacionMcp(data.map(item => item.id).join(',')).pipe(
          map(asociacion => {
            data.forEach(element => {
              const mpcEditar = asociacion.find(item => item.materiaCursoPeriodoId === element.id);
              if (mpcEditar) {
                element.course = mpcEditar.course;
                element.classroomCourseId = mpcEditar.classroomCourseId;
              } else {
                element.classroomCourseId = 0;
                element.course = 0;
              }
            });
            return data;
          })
        );
      })
    );

    this.materiasPeriodo$ = combineLatest(([mcpsConCourses$, this.classroomService.cambios$])).pipe(
      map(([mcps, cambios]) => {
        if (cambios && cambios.accion === 'materia-update') {
          cambios.obj.forEach(item => {
            const index = mcps.findIndex(materia => +materia.id === +item.materiaCursoPeriodoId);
            if (index > -1) {
              mcps[index].classroomCourseId = +item.classroomCourseId || 0;
              mcps[index].course = item.course;
            }
          });
        }
        return mcps;
      })
    );

    this.courses$ = this.classroomService.getClassroomClasses().pipe(shareReplay(1));

    if (+this.activeTab === 1) {
      this.comentariosService.getComentariosPorObjeto(this._eventoUnidad.id, 'unidadevento').subscribe(res => {
        this.comentariosEvento = this.estudioService.extractData(res);
      });
      this.editMainContent = false;
    }

    this.buildForm();

    this.gapiPickerSubscriber = this.pickerService.getPickerServiceObservable().subscribe(evt => {
      if (evt.tipo === 'agregarRecursos' && evt.targetTipo === 'unidadevento' && this._eventoUnidad.id === evt.targetID) {
        this._eventoUnidad.recursos = this._eventoUnidad.recursos.concat(evt.elementos);
      }
    });

    this.eventosMateriaSubject = new BehaviorSubject(this._eventoUnidad.eventoMaterias);
    this.eventosMateria$ = this.eventosMateriaSubject.asObservable();

    this.tareas$ = mcpsConCourses$.pipe(
      concatMap(data => {
        const ids = this.globalService.unique(data.map(item => item.classroomCourseId).filter(item => item));
        return from(ids).pipe(
          flatMap(id => {
            return this.classroomService.getClassroomCourswork(id).pipe(
              catchError(err => {
                return [];
              })
            );
          }),
          toArray()
        );
      }),
      map(data => {
        let res = [];
        data.forEach(item => {
          res = res.concat(item);
        });
        return res;
      }),
      shareReplay(1)
    );

  }

  ngAfterViewInit() {
    if (+this._eventoUnidad.evento.categoriaID === 81 && +this.activeTab === 0) {
      this.pickerService.createAdvancedClassRoomButton(
        'classroomshare',
        {
          title: this._eventoUnidad.evento.nombre,
          body: this._eventoUnidad.evento.resumenTXT
        }
      );
      this.classroomButtonLoaded = true;
    }
  }

  ngOnDestroy() {
    this.gapiPickerSubscriber.unsubscribe();
  }

  onChangeTab(index: number) {
    if (index === 0) {
      this.editMainContent = true;
      if (!this.classroomButtonLoaded && +this._eventoUnidad.evento.categoriaID === 81) {
        this.pickerService.createAdvancedClassRoomButton(
          'classroomshare',
          {
            title: this._eventoUnidad.evento.nombre,
            body: this._eventoUnidad.evento.resumen
          }
        );
        this.classroomButtonLoaded = true;
      }
    } else {
      this.comentariosService.getComentariosPorObjeto(this._eventoUnidad.id, 'unidadevento').subscribe(res => {
        this.comentariosEvento = this.estudioService.extractData(res);
      });
      this.editMainContent = false;
    }
  }

  buildForm() {
    const currTipoEvento = +this._eventoUnidad.id !== 0 ? this._eventoUnidad.evento.categoriaID : '',
      currNombre = this._eventoUnidad.evento.nombre.length > 0 ? this._eventoUnidad.evento.nombre : '',
      currCursos = +this._eventoUnidad.id !== 0 ?
        this._eventoUnidad.evento.cursos
          .map(curso => {
            return curso.id;
          }) : '',
      currAreas = +this._eventoUnidad.id !== 0 ?
        this._eventoUnidad.evento.materias
          .map(materia => {
            return materia.id;
          }) : '',
      currAmbitos = +this._eventoUnidad.id !== 0 ?
        this._eventoUnidad.evento.ambitos.map(ambito => {
          return ambito.id;
        }) : '',
      currTags = +this._eventoUnidad.id !== 0 ?
        this._eventoUnidad.evento.tags.map(tag => {
          return tag.id;
        }) : '',
      currEditores = +this._eventoUnidad.id !== 0 ?
        this._eventoUnidad.evento.editores.map(editor => {
          return editor.id;
        }) : '';
    this.eventoForm = this.fb.group({
      nombre: [currNombre, [Validators.required]],
      resumen: [this._eventoUnidad.evento.resumen],
      tipoEvento: [currTipoEvento, [Validators.required]],
      cursos: [currCursos],
      areas: [currAreas],
      ambitos: [currAmbitos],
      tags: [currTags],
      profesores: [currEditores]
    })
    ;
  }

  agregarEventoMateria(idMCP) {
    if (this._eventoUnidad.eventoMaterias
        .filter(e => (+e.id === 0 && e.materiaCursoPeriodoID === idMCP)).length < 1
      || Date.parse(this._eventoUnidad.eventoMaterias[this._eventoUnidad.eventoMaterias.length - 1].fechaAplicar)) {

      this.classroomService.crearEventoFechaMateria({
        id: 0,
        duracion: 0,
        isCompletado: false,
        fechaIsCompletado: '',
        fechaAplicar: '',
        fechaEntregaLimite: '',
        unidadEventoID: this._eventoUnidad.id,
        materiaCursoPeriodoID: idMCP
      }).subscribe(res => {
        this._eventoUnidad.eventoMaterias.push(res);
      });
    }
  }

  eliminarEventoMateria(eventoMateria) {
    const indiceEventoMateria = this._eventoUnidad
      .eventoMaterias
      .findIndex(e => +e.id === +eventoMateria.id && +e.materiaCursoPeriodoID === +eventoMateria.materiaCursoPeriodoID);
    if (+eventoMateria.id === 0) {
      // Elemento sin persistencia.
      this._eventoUnidad.eventoMaterias.splice(indiceEventoMateria, 1);
      this.snackBar.open(`El evento se ha eliminado.`, null, {duration: 2500});
    } else {
      // Elemento registrado en base de datos.
      this.unidadEtapasService.eliminarEventoMateria(eventoMateria.id).subscribe(() => {
        this._eventoUnidad.eventoMaterias.splice(indiceEventoMateria, 1);
        this.unidadEtapasService.eliminarObjeto('evento-calendario', eventoMateria);
        this.snackBar.open(`El evento se ha eliminado.`, null, {duration: 2500});
      }, err => {
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `No ha sido posible guardar la meta. <br> Código de error: ${err.statusText}`
        });
      });
    }
  }

  guardar() {
    const formVals = this.eventoForm.value;
    this.guardando = true;
    this._eventoUnidad.evento.nombre = formVals.nombre;
    this._eventoUnidad.evento.resumen = formVals.resumen;
    this._eventoUnidad.evento.categoria = {id: formVals.tipoEvento};
    this._eventoUnidad.evento.categoriaID = formVals.tipoEvento;
    this._eventoUnidad.evento.materias = formVals.areas.length > 0 ? formVals.areas.map(materia => {
      return {id: materia};
    }) : [];
    this._eventoUnidad.evento.cursos = formVals.cursos.length > 0 ? formVals.cursos.map(curso => {
      return {id: curso};
    }) : [];
    this._eventoUnidad.evento.ambitos = formVals.ambitos.length > 0 ? formVals.ambitos.map(ambito => {
      return {id: ambito};
    }) : [];
    this._eventoUnidad.evento.tags = formVals.tags.length > 0 ? formVals.tags.map(tag => {
      return {id: tag};
    }) : [];
    this._eventoUnidad.evento.editores = formVals.profesores.length > 0 ? formVals.profesores.map(editor => {
      return {id: editor};
    }) : [];


    if (+this._eventoUnidad.id !== 0) {
      this.estudioService.actualizarEvento(this._eventoUnidad).subscribe(resp => {
        this.imageDelete.reset();
        this.estudioService.actualizarElemento('evento', resp);
        this.unidadEtapasService.actualizarCalendario(resp);
        this.modalService.cerrarModal();
      }, err => {
        this.guardando = false;
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `No ha sido posible guardar la meta. <br> Código de error: ${err.statusText}`
        });
      });
    } else {
      this.estudioService.crearEvento(this._eventoUnidad.evento).subscribe(resp => {
        this.imageDelete.reset();
        const nuevoEvento = new Evento(this.estudioService.extractData(resp));
        this.estudioService.actualizarLista(nuevoEvento, 'evento');
        this.modalService.cerrarModal();
      }, err => {
        this.guardando = false;
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `No ha sido posible guardar la meta. <br> Código de error: ${err.statusText}`
        });
      });
    }
  }

  cancelar() {
    this.modalService.cerrarModal();
  }

  loadGPicker() {
    this.pickerService.apiLoad(this._eventoUnidad.id, 'unidadevento');
  }

  eliminarRecurso(recurso) {
    if (this._eventoUnidad.recursos.filter(rec => rec.id === recurso.id).length > 0) {
      const indiceRecurso = this._eventoUnidad.recursos.findIndex(rec => +recurso.id === +rec.id);
      this.unidadEtapasService.eliminarRecurso(recurso.id).subscribe(() => {
        const objeto = {targetID: this._eventoUnidad.id, recurso};
        this._eventoUnidad.recursos.splice(indiceRecurso, 1);
        this.unidadEtapasService.eliminarObjeto('recurso-evento', objeto);
        this.snackBar.open(`El recurso ${recurso.nombre} ha sido eliminado correctamente.`,
          null,
          {duration: 2500});
      }, err => {
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `No ha sido posible eliminar el recurso. <br> Código de error: ${err.statusText}`
        });
      });
    }
  }

  estadoRecursoEstudiantes(recurso) {
    recurso.isVisibleToStudent = !recurso.isVisibleToStudent;
    this.unidadEtapasService.actualizarRecurso(recurso).subscribe(() => {
      const objeto = {targetID: this._eventoUnidad.id, recurso};
      this.unidadEtapasService.actualizarObjeto('recurso-evento', objeto);
      this.snackBar.open(`El recurso ${recurso.nombre} ha sido actualizado correctamente.`,
        null,
        {duration: 2500});
    }, err => {
      recurso.isVisibleToStudent = !recurso.isVisibleToStudent;
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No ha sido posible eliminar el recurso. <br> Código de error: ${err.statusText}`
      });
    });
  }

  /**
   * Verifica si la fecha del nuevo EventoMateriaCursoPeriodo esta en la coleccion,
   * Si existe la fecha, resetea el valor y retorna Msge de error.
   * @param eventoMateria Se evalua la coleccion de Evento X MCP
   * @param materiaPeriodo Periodo de MCP
   * @param event evento del DatePicker que contiene la nueva fecha
   */
  // FIXME:
  setDate(eventoMateria, materiaPeriodo, event) {
    let nuevaFecha = new Date(event.value);
    nuevaFecha.setHours(0, 0, 0, 0);
    // evaluar si ka fecha en event.target.value esta en la coleccion
    // si esta en la coleccion hacer reset del valor y mostrar el msge
    const eventoMaterias = this._eventoUnidad.eventoMaterias.filter(evMat => {
      return +evMat.materiaCursoPeriodoID === +materiaPeriodo.id
        && +evMat.id !== 0;
    });

    eventoMaterias.map(mat => {
      const d = new Date(mat.fechaAplicar);
      d.setHours(0, 0, 0, 0);
      if (d.getTime() === nuevaFecha.getTime()) {
          event.target.value = '';
          this.snackBar.open('Error:  No se puede repetir la fecha para un curso.', 'X');
          // this.customAlertService.setCustomMessage({
          //   tipo: 'error',
          //   texto: `No se puede repetir la fecha para un curso.`
          // });
          return;
        }
    });
    eventoMateria.fechaAplicar = event.target.value;
  }// end FIXME:

  setEstadoMCP(evento) {
    const id = evento.id,
      estado = !evento.isCompletado;
    this.unidadEtapasService.setEstadoMCP(id, estado).subscribe(() => {
      evento.isCompletado = estado;
      this._eventoUnidad.eventoMaterias.find(item => item.id === evento.id).isCompletado = estado;
      this.unidadEtapasService.actualizarObjeto('evento-materia-estado', evento);
    }, err => {
      console.error(err);
    });
  }
}
